export type ApiBooleanFlag = boolean | number | string | null | undefined;

export const isApiBooleanFlagEnabled = (value: ApiBooleanFlag): boolean => {
	if (typeof value === 'string') {
		return ['1', 'true'].includes(value.trim().toLowerCase());
	}

	return value === true || value === 1;
};
